import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import useJiriHeaderItems from '@/modules/jiri/useJiriHeaderItems'
import Profile from '@/modules/profile/Profile'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useEffect } from 'react'
import { Platform, View } from 'react-native'

export default function ProfilePage() {
  const dispatch = useAppDispatch()
  const jiriHeaderItems = useJiriHeaderItems()
  const headerLeftItems = useWebBackButton('/forms')
  const [groupedBackgroundColor] = usePlatformColor('systemGroupedBackgroundColor')
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)
  const balance = useAppSelector(state => state.usageAndBalance.debitBalance.balance)
  const isOwnerOrAdmin = useAppSelector(state => state.currentUser.isOwnerOrAdmin)

  useEffect(() => {
    dispatch(getUsageAndBalanceThunk())
  }, [dispatch])

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  return (
    <View style={{ flex: 1 }}>
      <Stack.Screen
        options={{
          title: '我的',
          ...(Platform.OS !== 'ios' && {
            contentStyle: { backgroundColor: groupedBackgroundColor },
            headerStyle: { backgroundColor: groupedBackgroundColor },
          }),
          ...buildScreenHeaderItems({ left: headerLeftItems, right: jiriHeaderItems }),
        }}
      />
      <Profile currentUser={currentUser} balance={balance} isOwnerOrAdmin={isOwnerOrAdmin} />
    </View>
  )
}
